<div class="container" *ngIf="customerId; else missingCustomer">
    <portals-name-avatar
        [fullName]="user ? user.firstName + ' ' + user.lastName : ''"
    ></portals-name-avatar>
    <div class="main">
        <textarea
            nz-input
            placeholder="Write a note..."
            [nzAutosize]="{ minRows: 3, maxRows: 8 }"
            [(ngModel)]="content"
        ></textarea>
        <div class="actions">
            <button nz-button nzType="default" (click)="cancel()">
                Cancel
            </button>
            <button
                *ngIf="content !== ''"
                nz-button
                nzType="primary"
                (click)="save()"
            >
                Add Note
            </button>
        </div>
    </div>
</div>

<ng-template #missingCustomer>
    <span class="text-orange-500">
        Unable to write a note for an unknown patient.
    </span>
</ng-template>
